import {
  Device,
  IFalconTheme,
  Image,
  ImageSizeVariant,
  ResponsiveTypography,
  ResponsiveTypographyVariant,
  useDeviceViewport,
  withTheme,
} from '@se-admin/falcon';
import { i18n } from '@secret-escapes/i18n';
import * as React from 'react';
import { TranslationsContext } from '../../common/contexts';
import { BEST_PRICE_URL, ENDS_SOON_URL, HAND_PICKED_URL } from './Proposition.assets';
import {
  ImageContainer,
  ImageText,
  MainContainer,
  PropositonContainer,
  TitleWrapper,
} from './Proposition.styles';

export interface IPropositionProps {
  theme?: IFalconTheme;
}

/**
 * Proposition class presents a view for Secret Escapes' consumer proposition
 */
const Proposition: React.FunctionComponent<IPropositionProps> = () => {
  const deviceViewport: Device = useDeviceViewport();
  const imageSize: ImageSizeVariant =
    deviceViewport === Device.mobile ? ImageSizeVariant.extraSmall : ImageSizeVariant.small;

  return (
    <TranslationsContext.Consumer>
      {({ translations }) => (
        <MainContainer data-testid="proposition">
          <TitleWrapper>
            <ResponsiveTypography variant={ResponsiveTypographyVariant.t5SansBold}>
              {i18n('proposition.howWeWork', [], translations)}
            </ResponsiveTypography>
          </TitleWrapper>

          <PropositonContainer>
            <ImageContainer>
              <Image
                alt={''}
                size={imageSize}
                srcSet={[
                  {
                    src: HAND_PICKED_URL,
                  },
                ]}
              />
              <ImageText variant={ResponsiveTypographyVariant.micro}>
                {i18n('proposition.handpickedHotels', [], translations)}
              </ImageText>
            </ImageContainer>
            <ImageContainer>
              <Image
                alt={''}
                size={imageSize}
                srcSet={[
                  {
                    src: BEST_PRICE_URL,
                  },
                ]}
              />
              <ImageText variant={ResponsiveTypographyVariant.micro}>
                {i18n('proposition.unbeatablePrices', [], translations)}
              </ImageText>
            </ImageContainer>
            <ImageContainer>
              <Image
                alt={''}
                size={imageSize}
                srcSet={[
                  {
                    src: ENDS_SOON_URL,
                  },
                ]}
              />
              <ImageText variant={ResponsiveTypographyVariant.micro}>
                {i18n('proposition.dontLastLong', [], translations)}
              </ImageText>
            </ImageContainer>
          </PropositonContainer>
        </MainContainer>
      )}
    </TranslationsContext.Consumer>
  );
};

export default withTheme(Proposition);
